// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ABOUT_ME_PROFILE = "O mne";
export const BEFORE_BIRTH_1 = "E\u0161te";
export const BEFORE_BIRTH_2 = "do p\u00f4rodu.";
export const CHANGE = "Zme\u0148";
export const EDIT_PROFILE_SETTINGS = "Zme\u0148 \u00fadaje";
export const FAVORITE_USERS = "Moji ob\u013e\u00faben\u00ed";
export const HAVE_ME_AS_FAVORITE = "Maj\u00fa ma medzi ob\u013e\u00faben\u00fdmi";
export const I_AM_MEMBER_OF_GROUPS = "Patr\u00edm do skup\u00edn";
export const number_DAYS = ["%(number)s de\u0148", "%(number)s dni", "%(number)s dn\u00ed"];
export const PROFILE_SUMMARY__IN_num_PREGNANCY_WEEK = "v %(num)s. t\u00fd\u017edni tehotenstva";
export const PROFILE_SUMMARY__name_IS_in_num_pregnancy_week = "%(name)s je %(in_num_pregnancy_week)s";
